import React from 'react';
import { connect } from 'react-redux';
import { memo } from 'common/hocs/memo';
import { mapDispatchToProps, mapStateToProps } from './product-maps';
import { ProductLogicProps } from './product.types';
import { useProductLogic } from './use-product-logic';
import { ProductCard } from 'common/components/product-card/product-card';

export const ProductLogic = memo<ProductLogicProps>(function ProductLogic({
  className,
  type = 'large-card',
  elementBlock = 'not set',
  product,
  subtitle,
  inBasket,
  isBasketLoading,
  qty = 0,
  productPosition,
  addToBasket,
  removeFromBasket,
  ratings,
  updateCartItem,
  inWidget,
  inShoppingList,
  addToShoppingList,
  removeFromShoppingList,
  isSponsored,
}) {
  const {
    productRef,
    review,
    label,
    handleAddToCart,
    handleUpdateCart,
    handleRemoveFromCart,
    onClick,
    toggleShoppingList,
  } = useProductLogic({
    elementBlock,
    product,
    qty,
    productPosition,
    addToBasket,
    removeFromBasket,
    ratings,
    updateCartItem,
    addToShoppingList,
    removeFromShoppingList,
  });

  return (
    <ProductCard
      className={className}
      product={product}
      subtitle={subtitle}
      productPosition={productPosition}
      ref={productRef}
      type={type}
      label={label}
      inBasket={inBasket}
      isBasketLoading={isBasketLoading}
      qty={qty}
      onClick={onClick}
      onCartAdd={handleAddToCart}
      onQtyUpdate={handleUpdateCart}
      onCartRemove={handleRemoveFromCart}
      onShoppingListToggle={toggleShoppingList}
      ratings={review}
      inWidget={inWidget}
      inShoppingList={inShoppingList}
      elementBlock={elementBlock}
      isSponsored={isSponsored}
    />
  );
});

export const Product = connect(mapStateToProps, mapDispatchToProps)(ProductLogic);
